/**
 * @license lucide-react-native v0.474.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const childDefaultAttributes = {
  fill: defaultAttributes.fill,
  stroke: defaultAttributes.stroke,
  strokeWidth: defaultAttributes.strokeWidth,
  strokeLinecap: defaultAttributes.strokeLinecap,
  strokeLinejoin: defaultAttributes.strokeLinejoin
};

export { childDefaultAttributes, defaultAttributes as default };
//# sourceMappingURL=defaultAttributes.js.map
